import React, { useState, useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import { GoTrash } from "react-icons/go";
import { FaPlus, FaChevronDown } from "react-icons/fa6";
import { BsToggleOn, BsToggleOff } from "react-icons/bs";
import { NumericFormat } from 'react-number-format';
import api from '../../../../hooks/api';
import './ShippingMethods.css';
import config from '../../../../config';

function ShippingMethods({ businessHook }) {
    const { businessId } = businessHook || {};

    const [allPostCenters, setAllPostCenters] = useState([]);
    const [userMethods, setUserMethods] = useState([]);
    const [selectedOption, setSelectedOption] = useState("");
    const [loading, setLoading] = useState(true);
    const [disable, setDisable] = useState(false);
    const [hasSavedData, setHasSavedData] = useState(false);

    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    
    const fetchedBusinessIdRef = useRef(null);
    const dropdownRef = useRef(null);

    // تابع اصلاح و ساخت آدرس کامل تصویر
    const getImageUrl = (path) => {
        if (!path) return '';
        if (path.startsWith('http://') || path.startsWith('https://')) {
            return path;
        }
        
        const baseUrl = (config.api.imageURL || config.api.rootURL || '').replace(/\/$/, '');
        const cleanPath = path.startsWith('/') ? path : `/${path}`;
        
        return `${baseUrl}${cleanPath}`;
    };

    useEffect(() => {
        if (businessId && fetchedBusinessIdRef.current !== businessId) {
            fetchedBusinessIdRef.current = businessId;
            fetchInitialData();
        }
    }, [businessId]);

    // بستن دراپ‌داون با کلیک بیرون از آن
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchQuery("");
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    const fetchInitialData = async () => {
        try {
            setLoading(true);
            const [centersResponse, savedResponse] = await Promise.all([
                api.get('post/centers'),
                api.post('post/center/value/by-business', { business_id: businessId })
            ]);

            const centersData = centersResponse.data.data || [];
            setAllPostCenters(centersData);

            const savedValues = savedResponse.data.data || [];
            setHasSavedData(savedValues.length > 0);

            const initialUserMethods = savedValues.map(saved => {
                const originalInfo = centersData.find(c => c.id === saved.id_post_center);
                if (!originalInfo) return null;

                let roundedPrice = "";
                if (saved.price) {
                    roundedPrice = Math.floor(parseFloat(saved.price));
                }

                return {
                    id: saved.id_post_center,
                    title: originalInfo.title,
                    icon_url: originalInfo.icon_url,
                    isActive: saved.isActive_post_center == 1 || saved.isActive_post_center === "1" || saved.isActive_post_center === true,
                    price: roundedPrice,
                    prepayment: saved.prepayment == 1 || saved.prepayment === "1" || saved.prepayment === true,
                    afterpayment: saved.afterpayment == 1 || saved.afterpayment === "1" || saved.afterpayment === true,
                    isNew: false
                };
            }).filter(Boolean);

            setUserMethods(initialUserMethods);
            setLoading(false);

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const handleAddMethod = () => {
        if (!selectedOption) return;

        const methodToAdd = allPostCenters.find(m => m.id.toString() === selectedOption);
        if (methodToAdd) {
            const newMethod = {
                id: methodToAdd.id,
                title: methodToAdd.title,
                icon_url: methodToAdd.icon_url,
                isActive: true,
                price: "",
                prepayment: true,
                afterpayment: false,
                isNew: true
            };

            setUserMethods([newMethod, ...userMethods]);
            setSelectedOption("");
            setSearchQuery("");
        }
    };

    const handleDeleteMethod = (id) => {
        setUserMethods(userMethods.filter(m => m.id !== id));
    };

    const handleUpdateMethod = (id, field, value) => {
        setUserMethods(prev => prev.map(m => {
            if (m.id === id) {
                return { ...m, [field]: value };
            }
            return m;
        }));
    };

    const handleSave = () => {
        setDisable(true);
        const payload = userMethods.map(item => ({
            id_post_center: item.id,
            price: item.price ? item.price.toString().replace(/,/g, '') : "0",
            isActive_post_center: item.isActive,
            prepayment: item.prepayment,
            afterpayment: item.afterpayment,
            description: null,
        }));

        api.post(`post/center/value/store`, { business_id: businessId, details: payload })
            .then((response) => {
                setDisable(false);
                if (response.data.success) {
                    toast.success("تنظیمات ارسال با موفقیت ذخیره شد");
                    setHasSavedData(true);
                    setUserMethods(prev => prev.map(m => ({ ...m, isNew: false })));
                } else {
                    toast.error(response.data.message || "خطا در ذخیره سازی");
                }
            })
            .catch(() => {
                setDisable(false);
                toast.error("خطا در برقراری ارتباط با سرور");
            });
    };

    const availableOptions = allPostCenters.filter(
        center => !userMethods.some(userMethod => userMethod.id === center.id)
    );

    const filteredOptions = availableOptions.filter(opt =>
        opt.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const selectedObj = allPostCenters.find(i => i.id.toString() === selectedOption);

    if (loading) return <div className="shipping-loading">در حال دریافت اطلاعات...</div>;

    return (
        <div className="shipping-container">
            <div className="shipping-add-section">
                <div className="add-box-zarinpal">
                    <div className="custom-select-wrapper" ref={dropdownRef}>
                        <div
                            className={`custom-select-trigger ${isOpen ? 'open' : ''}`}
                            onClick={() => {
                                setIsOpen(!isOpen);
                                if (isOpen) setSearchQuery("");
                            }}
                        >
                            {selectedOption && selectedObj ? (
                                <div className="selected-item-view" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <img
                                        src={getImageUrl(selectedObj.icon_url)}
                                        alt={selectedObj.title}
                                        className="option-icon"
                                        onError={(e) => { e.target.onerror = null; }}
                                        style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                                    />
                                    <span>{selectedObj.title}</span>
                                </div>
                            ) : (
                                <span className="placeholder-text">انتخاب روش ارسال...</span>
                            )}
                            <FaChevronDown className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
                        </div>

                        {isOpen && (
                            <div className="custom-options-list">
                                <div className="custom-search-wrapper">
                                    <input
                                        type="text"
                                        className="custom-search-input"
                                        placeholder="جستجوی روش ارسال..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </div>

                                {filteredOptions.length > 0 ? (
                                    filteredOptions.map(opt => (
                                        <div
                                            key={opt.id}
                                            className="custom-option-item"
                                            onClick={() => {
                                                setSelectedOption(opt.id.toString());
                                                setIsOpen(false);
                                                setSearchQuery("");
                                            }}
                                            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                                        >
                                            <img
                                                src={getImageUrl(opt.icon_url)}
                                                alt={opt.title}
                                                className="option-icon"
                                                onError={(e) => { e.target.onerror = null; }}
                                                style={{ width: '24px', height: '24px', objectFit: 'contain' }}
                                            />
                                            <span>{opt.title}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="empty-options">
                                        {availableOptions.length === 0 ? "همه روش‌ها اضافه شده‌اند" : "نتیجه‌ای یافت نشد"}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    <button
                        className={`btn-add-zarin ${selectedOption ? 'active-btn' : ''}`}
                        onClick={handleAddMethod}
                        disabled={!selectedOption}
                    >
                        <FaPlus />
                        افزودن
                    </button>
                </div>
            </div>

            <div className="shipping-list">
                {userMethods.map((method) => (
                    <div 
                        key={method.id} 
                        className={`zarinpal-card ${method.isNew ? 'unsaved-card' : (method.isActive ? 'active-border' : '')}`}
                    >
                        {/* --- هدر کارت --- */}
                        <div className="zarin-header">
                            {/* بخش سوئیچ اصلی (سمت راست هدر مطابق تصویر دوم) */}
                            <div 
                                className="shipping-toggle-btn"
                                onClick={() => handleUpdateMethod(method.id, 'isActive', !method.isActive)}
                                title={method.isActive ? 'غیرفعال‌سازی' : 'فعال‌سازی'}
                            >
                                {method.isActive ? (
                                    <BsToggleOn size={36} color="#4caf50" />
                                ) : (
                                    <BsToggleOff size={36} color="#ccc" />
                                )}
                            </div>

                            {/* بخش وسط و عنوان */}
                            <div className="zarin-header-title-group">
                                <span className="zarin-title">{method.title}</span>
                                <img
                                    src={getImageUrl(method.icon_url)}
                                    alt={method.title}
                                    className="list-card-icon"
                                    onError={(e) => { e.target.onerror = null; }}
                                />
                            </div>

                            {/* بخش چپ: دکمه حذف */}
                            <div className="zarin-header-left">
                                <div
                                    className="shipping-delete-btn"
                                    onClick={() => handleDeleteMethod(method.id)}
                                    title="حذف روش ارسال"
                                >
                                    <GoTrash size={18} color="#f44336" />
                                </div>
                            </div>
                        </div>

                        {/* --- بدنه کارت --- */}
                        <div className={`zarin-body ${!method.isActive ? 'disabled-content' : ''}`}>
                            {/* سوئیچ پس پرداخت */}
                            <div className="zarin-row">
                                <span className="zarin-label">پس پرداخت (در محل)</span>
                                <div 
                                    className="shipping-toggle-btn-small"
                                    onClick={() => method.isActive && handleUpdateMethod(method.id, 'afterpayment', !method.afterpayment)}
                                >
                                    {method.afterpayment ? (
                                        <BsToggleOn size={32} color="#4caf50" />
                                    ) : (
                                        <BsToggleOff size={32} color="#ccc" />
                                    )}
                                </div>
                            </div>

                            {/* سوئیچ پیش پرداخت + مبلغ */}
                            <div className="zarin-column-wrapper" style={{ marginTop: '10px' }}>
                                <div className="zarin-row" style={{ marginBottom: method.prepayment ? '10px' : '0' }}>
                                    <span className="zarin-label">پیش پرداخت (آنلاین)</span>
                                    <div 
                                        className="shipping-toggle-btn-small"
                                        onClick={() => method.isActive && handleUpdateMethod(method.id, 'prepayment', !method.prepayment)}
                                    >
                                        {method.prepayment ? (
                                            <BsToggleOn size={32} color="#4caf50" />
                                        ) : (
                                            <BsToggleOff size={32} color="#ccc" />
                                        )}
                                    </div>
                                </div>

                                {method.prepayment && (
                                    <div className="zarin-input-wrapper-full">
                                        <div className="zarin-input-wrapper">
                                            <NumericFormat
                                                className="zarin-input"
                                                placeholder="مبلغ پیش پرداخت..."
                                                thousandSeparator={true}
                                                value={method.price}
                                                onValueChange={(values) => {
                                                    handleUpdateMethod(method.id, 'price', values.value);
                                                }}
                                                disabled={!method.isActive}
                                                style={{ width: '100%' }}
                                            />
                                            <span className="zarin-unit">تومان</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}

                {userMethods.length === 0 && (
                    <div className="empty-state-zarin">هیچ روش ارسالی فعال نشده است.</div>
                )}
            </div>

            <button
                className={`btn-submit-all ${disable ? 'disabled' : ''}`}
                onClick={!disable ? handleSave : null}
            >
                {disable ? 'در حال ثبت...' : (hasSavedData ? 'بروزرسانی نهایی تنظیمات' : 'ثبت نهایی تنظیمات')}
            </button>
        </div>
    );
}

export default ShippingMethods;
